import { useEffect, useState } from 'react';

import appService from '../../service/app.service';
import biService from '../../service/bi.service';
import BiRoleModify from './BiRoleModify';
import { ButtonUI, DebouncedInputUI } from '../Interface';

export default function BiRoleInformation({ roleState }) {
  const { roleId } = roleState;
  const [biRolePermissions, setBiRolePermissions] = useState([]);
  const [biReports, setBiReports] = useState([]);
  const [roleModalShow, setRoleModalShow] = useState(false);
  const [roleHasPermission, setRoleHasPermission] = useState(false);
  const [selectedBiReport, setSelectedBiReport] = useState(null);
  const [refreshPage, setRefreshPage] = useState(false);
  const [biRoles, setBiRoles] = useState([]);
  const [filter, setFilter] = useState({
    name: '',
  });

  useEffect(() => {
    fetchAllBiReport();
  }, []);

  const fetchData = async () => {
    if (!roleId) {
      return;
    }
    appService
      .getRoleInformation(roleId)
      .then((data) => {
        fetchBiRolePermissions(data[0]?.roleId);
      })
      .finally(() => {});
  };

  const fetchBiRolePermissions = async () => {
    appService
      .getBiPermissions(roleId)
      .then((data) => {
        setBiRolePermissions(data);
      })
      .finally(() => {});
  };

  const fetchAllBiReport = async () => {
    biService
      .allBiReports()
      .then((data) => {
        setBiReports(data);
      })
      .finally(() => {});
  };

  useEffect(() => {
    const mergedRoles = biReports.map((biRole) => {
      const permission = biRolePermissions.find(
        (permission) => permission.biReportId === biRole.id && permission.roleId === roleId
      );

      return {
        ...biRole,
        hasPermission: !!permission,
      };
    });

    setBiRoles(mergedRoles);
  }, [biReports, biRolePermissions, roleId]);

  useEffect(() => {
    fetchData();
  }, [roleId]);

  useEffect(() => {
    fetchData();
  }, [refreshPage]);

  return (
    <>
      <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6 max-h-[calc(100vh-10rem)] overflow-y-auto custom-scrollbar">
        <div>
          <div className="w-[250px] mb-3">
            <DebouncedInputUI
              label="Keresés"
              debounceMs={800}
              quickFilterSearchValue={filter?.name}
              setQuickFilterSearchValue={(newValue) => {
                setFilter((prevState) => ({
                  ...prevState,
                  name: newValue,
                }));
              }}
            />
          </div>
          <table className="mt-2 min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Menüpont
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Jogosult
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                ></th>
              </tr>
            </thead>
            <tbody>
              {biRoles
                .filter((biRole) => biRole.name.toLowerCase().includes(filter.name.toLowerCase()))
                .map((biRole, index) => (
                  <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}>
                    <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{biRole.name}</td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {biRole.hasPermission ? 'Jogosult' : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      <ButtonUI
                        onClick={() => {
                          setRoleModalShow(true);
                          setRoleHasPermission(biRole.hasPermission);
                          setSelectedBiReport(biRole.id);
                        }}
                        variant="gradient"
                        color="blue-gray"
                        size="sm"
                        disabled={!roleId}
                        text="Szerkesztés"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <BiRoleModify
        show={roleModalShow}
        onHide={() => setRoleModalShow(false)}
        hasPermission={roleHasPermission}
        roleId={roleId}
        selectedBiReport={selectedBiReport}
        refreshPage={refreshPage}
        setRefreshPage={setRefreshPage}
        biRoleState={{ biRolePermissions, setBiRolePermissions }}
      />
    </>
  );
}
